.gameBoardCenterWrapper {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  color: var(--ds-game-text);

  position: relative;

  /* height set by the GameBoard UI */
  height: 100%;

  & .gameBoardCenterCards {
    margin-bottom: 12px;
  }
}

.textInCenterWrapper {
  margin-bottom: 12px;
  text-align: center;
}

.cardsInCenter {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
}

.cardInCenterWrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cardCounter {
  position: absolute;
  top: 4px;
  left: 3px;
  padding: 0 6px;
  border-radius: 8px;
  background-color: #1a211e;
}

.dimDeck {
  opacity: 0.2;
}

.overlay {
  background: var(--ds-poker-green-darkest);
  /*backdrop-filter: blur(8px);*/

  border-radius: 16px;
  /* TODO seems like this varies a lot in the design per message */
  padding: 38px 24px 16px;
  width: 100%;

  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  position: absolute;

  text-align: center;

  & .overlayButton {
    margin-top: 16px;
  }

  & .overlayButton + .overlayButton {
    margin-top: 8px;
  }
}

.backButtonAndConfirm {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.actionButtons {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;

  & > :not(:first-child) {
    margin-top: 6px;
  }
}

.backButtonAndConfirm,
.actionButtons {
  margin-top: 14px;
}

.winnerBanner {
  position: absolute;

  text-align: center;

  background: var(--ds-highlight);
  border-radius: 12px;
  padding: 20px 12px;
  opacity: 0.95;

  top: 40px;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  width: 100%;

  & img {
    height: 40px;
    margin-right: 10px;
  }
}
